<template>
    <div
        id="tv-topnav"
        class="rl-mainItem">
        <div class="rl-row-1440">
            <div class="rl-flex rl-flex-center-v rl-navbar rl-flex-space-between">
                <div class="rl-navbar-brand sm-hidden">
                    <router-link
                        :to="{path:'/'}"
                        class="pc-brand">
                        <svg
                            viewBox="0 0 240 20"
                            class="icon">
                            <use xlink:href="#rltv_white"/>
                        </svg>
                    </router-link>
                </div>
                <div
                    class="rl-navbar-brand sm-show"
                    @click.prevent="toggleMenu('#tv-hamburger','#tv-level')">
                    <svg
                        viewBox="0 0 240 20"
                        class="icon">
                        <use xlink:href="#rltv_white"/>
                    </svg>
                    <svg
                        id="tv-hamburger"
                        viewBox="0 0 34 34"
                        class="arrow-icon icon-big m-arrow-icon">
                        <use xlink:href="#arrow_down"/>
                    </svg>
                </div>
                <transition name="fade">
                    <div
                        id="tv-level"
                        class="navbar-group rl-flex rl-flex-end rl-mainItem">
                        <!-- {{ categories }} -->
                        <div
                            v-if="categories"
                            ref="tvMenu"
                            class="navbar-menu rl-flex"
                            @mouseover="onMouseEnterMenu"
                            @mouseleave="onMouseLeaveMenu">
                            <div
                                v-for="(productItem, index) in categories"
                                :id="'category-'+productItem.ID"
                                :key="index"
                                :class="{'active':productHightlight==productItem.ID, 'hover':currentHoverID == productItem.ID}"
                                class="category"
                                @mouseover="currentHoverID = productItem.ID">
                                <div class="category-product rl-flex rl-flex-center-v sm-hidden">
                                    <router-link
                                        v-if="productItem.ID == 'ic'"
                                        :to="{path:'/iclone/'}"
                                        class="category-product-link rl-flex rl-flex-center-v"
                                        event=""
                                        @click.native.prevent="handleClick($event)">
                                        <svg
                                            viewBox="0 0 34 34"
                                            class="icon">
                                            <use xlink:href="#IC7"/>
                                        </svg>
                                        <span>{{ productItem.title }}</span>
                                    </router-link>
                                    <router-link
                                        v-if="productItem.ID == 'cc'"
                                        :to="{path:'/character-creator/'}"
                                        class="category-product-link rl-flex rl-flex-center-v"
                                        event=""
                                        @click.native.prevent="handleClick($event)">
                                        <svg
                                            viewBox="0 0 34 34"
                                            class="icon">
                                            <use xlink:href="#logo_cc"/>
                                        </svg>
                                        <span>{{ productItem.title }}</span>
                                    </router-link>
                                    <router-link
                                        v-if="productItem.ID == 'cta'"
                                        :to="{path:'/crazytalk-animator/'}"
                                        class="category-product-link rl-flex rl-flex-center-v"
                                        event=""
                                        @click.native.prevent="handleClick($event)">
                                        <svg
                                            viewBox="0 0 34 34"
                                            class="icon">
                                            <use xlink:href="#logo_cta"/>
                                        </svg>
                                        <span>{{ productItem.title }}</span>
                                    </router-link>
                                    <router-link
                                        v-if="productItem.ID == 'ct'"
                                        :to="{path:'/crazytalk/'}"
                                        class="category-product-link rl-flex rl-flex-center-v"
                                        event=""
                                        @click.native.prevent="handleClick($event)">
                                        <svg
                                            viewBox="0 0 34 34"
                                            class="icon">
                                            <use xlink:href="#logo_ct"/>
                                        </svg>
                                        <span>{{ productItem.title }}</span>
                                    </router-link>
                                    <router-link
                                        v-if="productItem.ID == '3dx'"
                                        :to="{path:'/crazytalk/'}"
                                        class="category-product-link rl-flex rl-flex-center-v"
                                        event=""
                                        @click.native.prevent="handleClick($event)">
                                        <svg
                                            viewBox="0 0 34 34"
                                            class="icon">
                                            <use xlink:href="#3dx"/>
                                        </svg>
                                        <span>{{ productItem.title }}</span>
                                    </router-link>
                                    <!-- <router-link
                                        v-if="productItem.ID == 'others'"
                                        :to="{path:'/'}"
                                        class="category-product-link rl-flex rl-flex-center-v"
                                        event=""
                                        @click.native.prevent="handleClick($event)">
                                        <svg
                                            viewBox="0 0 34 34"
                                            class="icon">
                                            <use xlink:href="#other"/>
                                        </svg>
                                        <span>{{ productItem.title }}</span>
                                    </router-link> -->
                                </div>
                                <div
                                    class="category-product rl-flex rl-flex-center-v sm-show"
                                    @click="toggleProductLevel('#category-'+productItem.ID,'#tv-product-menu-'+productItem.ID, productItem.ID)">
                                    <router-link
                                        v-if="productItem.ID == 'ic'"
                                        :to="{path:'/iclone/'}"
                                        class="category-product-link rl-flex rl-flex-center-v"
                                        event=""
                                        @click.native.prevent="handleClick($event)">
                                        <svg
                                            viewBox="0 0 34 34"
                                            class="icon">
                                            <use xlink:href="#IC7"/>
                                        </svg>
                                        <span>{{ productItem.title }}</span>
                                    </router-link>
                                    <router-link
                                        v-if="productItem.ID == 'cc'"
                                        :to="{path:'/character-creator/'}"
                                        class="category-product-link rl-flex rl-flex-center-v"
                                        event=""
                                        @click.native.prevent="handleClick($event)">
                                        <svg
                                            viewBox="0 0 34 34"
                                            class="icon">
                                            <use xlink:href="#logo_cc"/>
                                        </svg>
                                        <span>{{ productItem.title }}</span>
                                    </router-link>
                                    <router-link
                                        v-if="productItem.ID == 'cta'"
                                        :to="{path:'/crazytalk-animator/'}"
                                        class="category-product-link rl-flex rl-flex-center-v"
                                        event=""
                                        @click.native.prevent="handleClick($event)">
                                        <svg
                                            viewBox="0 0 34 34"
                                            class="icon">
                                            <use xlink:href="#logo_cta"/>
                                        </svg>
                                        <span>{{ productItem.title }}</span>
                                    </router-link>
                                    <router-link
                                        v-if="productItem.ID == 'ct'"
                                        :to="{path:'/crazytalk/'}"
                                        class="category-product-link rl-flex rl-flex-center-v"
                                        event=""
                                        @click.native.prevent="handleClick($event)">
                                        <svg
                                            viewBox="0 0 34 34"
                                            class="icon">
                                            <use xlink:href="#logo_ct"/>
                                        </svg>
                                        <span>{{ productItem.title }}</span>
                                    </router-link>
                                    <router-link
                                        v-if="productItem.ID == '3dx'"
                                        :to="{path:'/crazytalk/'}"
                                        class="category-product-link rl-flex rl-flex-center-v"
                                        event=""
                                        @click.native.prevent="handleClick($event)">
                                        <svg
                                            viewBox="0 0 34 34"
                                            class="icon">
                                            <use xlink:href="#3dx"/>
                                        </svg>
                                        <span>{{ productItem.title }}</span>
                                    </router-link>
                                    <!-- <router-link
                                        v-if="productItem.ID == 'others'"
                                        :to="{path:'/'}"
                                        class="category-product-link rl-flex rl-flex-center-v"
                                        event=""
                                        @click.native.prevent="handleClick($event)">
                                        <svg
                                            viewBox="0 0 34 34"
                                            class="icon">
                                            <use xlink:href="#other"/>
                                        </svg>
                                        <span>{{ productItem.title }}</span>
                                    </router-link> -->
                                </div>
                                <div
                                    :id="'tv-product-menu-'+productItem.ID"
                                    class="category-menu-wapper rl-mainItem clearfix">
                                    <ul class="category-menu">
                                        <li
                                            v-for="(level1, index) in productItem.items"
                                            :key="index">
                                            <a
                                                :href="'#/' + productItem.link+'/'+level1.type"
                                                class="c1-title"
                                                @click="processingAfterCatelogClick(level1.ID+'=0+'+level1.URL, productItem.ID+'-'+level1.Name, 'all')">
                                                {{ level1.text }}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>
                <div class="clearfix"/>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from "vuex";
    import store from "@/store";
    export default {
        data () {
            return {
                productHightlight: "",
                mobileCurrentCatalog: "",
                productNameInUrl: {
                    ic: "iclone",
                    cc: "character-creator",
                    cta: "crazytalk-animator"
                },
                closeTopNavMenuTimeout: undefined,
                currentHoverID: "",
                breakpontForTopNavMenuModeChange: 1100
            };
        },
        computed: {
            ...mapGetters({ categories: "categories" })
        },
        watch: {
            $route (to, from) {
                this.checkProductHightlight(to.params.product, to.params.type);
            }
        },
        mounted () {
            let vm = this;
            this.checkProductHightlight("1:", vm.$route.params.product, vm.$route.params.type);
            $(window).scroll(function () {
                var scroll = $(window).scrollTop();
                var rltopnav = $("#rl-topnavarea").height();
                if (scroll >= rltopnav) {
                    $("body").addClass("affix-body");
                    $("#tv-topnav").addClass("affix");
                } else {
                    $("body").removeClass("affix-body");
                    $("#tv-topnav").removeClass("affix");
                }
                vm.currentHoverID = "";
            });
            $(window).click(function (e) {
                if (!(vm.$refs.tvMenu && vm.$refs.tvMenu.contains(e.target))) {
                    vm.currentHoverID = "";
                }
            });
        },
        methods: {
            handleClick (e) {
                e.preventDefault();
            },
            toggleMenu (openIocn, subItemOpen) {
                if ($("#tv-topnav").width() <= 1750) {
                    $(openIocn).toggleClass("openMenu");
                    $(subItemOpen).toggleClass("subItemOpen");
                }
            },
            toggleProductLevel (openIocn, subItemOpen, product) {
                if (this.mobileCurrentCatalog != product) {
                    $(".category").removeClass("openMenu");
                    $(".category-menu-wapper").removeClass("subItemOpen");
                    this.mobileCurrentCatalog = product;
                }
                this.toggleMenu(openIocn, subItemOpen);
            },
            processingAfterCatelogClick (updateCurrentLevel, action, actionCategorySubname) {
                $(".category").removeClass("hover");
                if ($("#tv-topnav").width() <= 1750) {
                    this.toggleMenu("#tv-hamburger", "#tv-level");
                }
            },
            checkProductHightlight (category, type) {
                var vm = this;
                function PNameConvertToID (params) {
                    return Object.keys(vm.productNameInUrl).find(
                        key =>
                            vm.productNameInUrl[key] === params
                    );
                }

                if (category !== undefined) {
                    this.productHightlight = PNameConvertToID(vm.$route.params.product);
                } else {
                    this.productHightlight = "";
                }
            },
            onMouseEnterMenu (e) {
                if (window.innerWidth > this.breakpontForTopNavMenuModeChange) {
                    clearTimeout(this.closeTopNavMenuTimeout);
                }
            },
            onMouseLeaveMenu (e) {
                if (window.innerWidth > this.breakpontForTopNavMenuModeChange) {
                    clearTimeout(this.closeTopNavMenuTimeout);
                    this.closeTopNavMenuTimeout = setTimeout(() => {
                        this.currentHoverID = "";
                    }, 1000);
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/rltvTop.vue